module.exports = __webpack_public_path__ + "media/images/front/icon_plus_wt-ce93fb2d41876b5dacc8c4d78c7c6e91.png";